import { Link } from "react-router-dom";
import { zones } from "@/data/zones";
import { servicesOptions } from "@/data/services";

const footerServices = servicesOptions.slice(0, 5);
const footerZones = zones.slice(0, 6);

const Footer = () => (
  <footer className="bg-brand-blue text-white" data-testid="footer">
    <div className="max-w-6xl mx-auto px-6 py-16 grid gap-10 md:grid-cols-4">
      <div className="space-y-4" data-testid="footer-brand">
        <img
          src="/assets/logo-fast-alu.png"
          alt="Fast Alu"
          className="h-14 w-auto"
          data-testid="footer-logo"
        />
        <p className="text-sm text-white/70" data-testid="footer-tagline">
          Sécurité, dépannage et menuiserie aluminium en Île-de-France.
        </p>
        <div className="space-y-2">
          <a
            href="tel:0184160307"
            className="block text-sm font-semibold"
            data-testid="footer-phone"
          >
            01 84 16 03 07
          </a>
          <a
            href="mailto:contact@fast-alu.com"
            className="block text-sm"
            data-testid="footer-email"
          >
            contact@fast-alu.com
          </a>
          <span className="block text-sm" data-testid="footer-site">
            fast-alu.fr
          </span>
        </div>
      </div>
      <div>
        <p className="font-heading text-lg uppercase" data-testid="footer-services-title">
          Services clés
        </p>
        <ul className="mt-4 space-y-2 text-sm">
          {footerServices.map((service) => (
            <li key={service.slug} data-testid={`footer-service-${service.slug}`}>
              <Link
                to={`/services/${service.slug}`}
                className="hover:text-brand-red"
                data-testid={`footer-service-link-${service.slug}`}
              >
                {service.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="font-heading text-lg uppercase" data-testid="footer-zones-title">
          Zones prioritaires
        </p>
        <ul className="mt-4 space-y-2 text-sm">
          {footerZones.map((zone) => (
            <li key={zone.slug} data-testid={`footer-zone-${zone.slug}`}>
              <Link
                to={`/${zone.slug}`}
                className="hover:text-brand-red"
                data-testid={`footer-zone-link-${zone.slug}`}
              >
                {zone.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <p className="font-heading text-lg uppercase" data-testid="footer-links-title">
          Liens utiles
        </p>
        <ul className="mt-4 space-y-2 text-sm">
          <li>
            <Link to="/services" data-testid="footer-link-services">
              Services
            </Link>
          </li>
          <li>
            <Link to="/zones" data-testid="footer-link-zones">
              Zones d’intervention
            </Link>
          </li>
          <li>
            <Link to="/guides" data-testid="footer-link-guides">
              Guides
            </Link>
          </li>
          <li>
            <Link to="/actualites" data-testid="footer-link-promos">
              Actualités & promotions
            </Link>
          </li>
          <li>
            <Link to="/contact" data-testid="footer-link-contact">
              Demander un devis
            </Link>
          </li>
          <li>
            <Link to="/mentions-legales" data-testid="footer-link-legal">
              Mentions légales
            </Link>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-white/15 text-center text-xs text-white/70 py-4" data-testid="footer-bottom">
      © {new Date().getFullYear()} Fast Alu. Tous droits réservés.
    </div>
  </footer>
);

export default Footer;
